export default {
  errors: [],
  success: false,
  stations: [],
  station: [],
  doctor: [],
  employees: [],
  coops: [],
  next_stations_url: "station",
  shouldAppend: true,
  search_keyword: "",
};
